import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { Heading, Modal, SecondaryButton } from '../../components';
import ContactChevalierForm from '../../components/ContactChevalierForm/ContactChevalierForm';
import { useContactChevalierRequest } from '../../hooks/useContactChevalierRequest';

import css from './ListingPage.module.css';

const SectionAuthorMaybe = props => {
  const { listing, currentUser, onManageDisableScrolling } = props;

  if (!listing?.id) {
    return null;
  }

  const {
    closeModal,
    error,
    initialValues,
    inProgress,
    isModalOpen,
    openModal,
    submitContactRequest,
    success,
  } = useContactChevalierRequest({ listing, currentUser });

  return (
    <section id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ContactChevalierForm.supportHeading" />
      </Heading>
      <div className={css.contactSupportCard}>
        <p className={css.contactSupportText}>
          <FormattedMessage id="ContactChevalierForm.supportBody" />
        </p>
        <SecondaryButton className={css.contactSupportButton} onClick={openModal}>
          <FormattedMessage id="ContactChevalierForm.supportCta" />
        </SecondaryButton>
        {success ? (
          <p className={css.contactSupportSuccess}>
            <FormattedMessage id="ContactChevalierForm.submitSuccess" />
          </p>
        ) : null}
      </div>
      <Modal
        id="ListingPage.contactChevalier"
        contentClassName={css.inquiryModalContent}
        isOpen={isModalOpen}
        onClose={closeModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ContactChevalierForm
          className={css.inquiryForm}
          initialValues={initialValues}
          onSubmit={submitContactRequest}
          inProgress={inProgress}
          error={error}
        />
      </Modal>
    </section>
  );
};

export default SectionAuthorMaybe;
